import { lazy } from 'react';

const Thunderbite = lazy(() => import(/* webpackChunkName: "thunderbite" */ './thunderbite-container.js'));

export default Thunderbite;
